// extracted by mini-css-extract-plugin
export default {"container":"Modal_container__Yn7oD","content":"Modal_content__+C9Xp","title":"Modal_title__SfYS8","lottie-container":"Modal_lottie-container__nfz1G","image":"Modal_image__Ta2Vv"};